import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AnalyticsData, TimeInterval} from "../../services/analytics-dashboard.service";

@Component({
    selector: 'app-dashboard-charts',
    templateUrl: './dashboard-charts.component.html',
    styleUrls: ['./dashboard-charts.component.scss']
})
export class DashboardChartsComponent implements OnInit, OnChanges {

    @Input()
    data: AnalyticsData;

    @Input()
    activeInterval: TimeInterval;

    activeMetric: string;

    metricsList = [
        {
            name: 'visitors',
            total: 0
        },
        {
            name: 'configurations',
            total: 0
        },
        {
            name: 'session_duration',
            total: 0
        },
        {
            name: 'configurations_per_session',
            total: 0
        },
        {
            name: 'sessions_per_visitor',
            total: 0
        },
        {
            name: 'saved_configurations',
            total: 0
        }
    ];

    constructor() {
    }

    ngOnInit() {
        this.activeMetric = 'visitors';
    }


    ngOnChanges(changes: SimpleChanges): void {
        if(changes.data && changes.data.currentValue) {
            this.metricsList.forEach((m) => m.total = 0);
            Object.keys(changes.data.currentValue.main).forEach((metricName) => {
                if(changes.data.currentValue.main[metricName].data.length > 0) {
                    let total = changes.data.currentValue.main[metricName].total;
                    let found = this.metricsList.find((m) => this.toCamelCase(m.name) === metricName);
                    if (found) {
                        if(metricName.match(/duration/i)) {
                            found.total = Number.parseFloat((total / 60).toFixed(2));
                        }else{
                            found.total = Number.parseFloat(Number.parseFloat(total).toFixed(2));
                        }
                    }
                }
            });
        }
    }

    metricChanged(metric) {
        this.activeMetric = metric;
    }

    toCamelCase(str) {
        let arr = str.replace(/\s/g, '_').split('_');
        let firstPart = arr[0];
        if(arr.length === 1){
            return firstPart;
        }
        let res = arr.slice(1).map((value) => value.charAt(0).toUpperCase() + value.slice(1)).join('');
        return firstPart + res;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard-charts/dashboard-charts.component.ts